import styled from "styled-components";
import { colors } from "./colors/color";

type DividerProps = {
  color?: string;
  variant?:'default' | 'light' | 'medium' | 'blue';
};


export const Divider = styled.div<DividerProps>`
    height: 1px;
    background-color: ${props => getDividerColor(props.color, props.variant)};
    margin:0;
    width:100%;
`;

function getDividerColor(color?: string, variant?: 'default' | 'light' | 'medium' | 'blue'): string
{
    if (color) return color;

    switch (variant) {
        case 'light':
            return colors.divider.light;
        case 'medium':
            return colors.divider.medium;
        case 'blue':
            return colors.divider.blue;
        default:
            return colors.divider.default;
    }
}